var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.781,
    height: 136.375,
    viewBox: "0 0 135.781 136.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M19.592,41.638a6.591,6.591,0,0,0-9.546,0,6.591,6.591,0,0,0,0,9.546L30.5,71.641a6.591,6.591,0,0,0,9.546,0L87.78,17.091c2.046-3.409,2.046-7.5-1.364-9.546C83.688,5.5,79.6,5.5,77.551,8.226L35.275,56.639Z",
    transform: "translate(32.913 21.776)",
    fill: "#05b4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M131.557,63.369a6.442,6.442,0,0,0-6.819,6.819,54.55,54.55,0,0,1-109.1,0A53.63,53.63,0,0,1,31.321,32c10.228-10.91,23.866-16.365,38.867-16.365A83.546,83.546,0,0,1,83.143,17c3.409,1.364,7.5-.682,8.864-4.773s-1.364-6.819-4.773-8.183h-.682A67.25,67.25,0,0,0,70.188,2C32.684,2,2,32.684,2,70.87A68.783,68.783,0,0,0,21.774,118.6a67.078,67.078,0,0,0,47.731,19.774,68.388,68.388,0,0,0,68.188-68.188C138.375,66.1,134.966,63.369,131.557,63.369Z",
    transform: "translate(-2 -2)",
    fill: "#05b4ef"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIco);
export default __webpack_public_path__ + "static/media/successIco.7835bce9454af3bf040b8bc24059a11e.svg";
export { ForwardRef as ReactComponent };